import { ReactNode, useMemo } from 'react';
import { Widget } from 'jamespot-front-business';
import { shallowEqual } from 'react-redux';
import { useAppSelector } from '../../../../redux/store';
import styled, { useTheme } from 'styled-components';

export const UIWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

/*
    DO NOT USE PADDING HERE (LOOK AT WIDGET STYLE PADDING COMPONENT)
*/
const WidgetStyle = ({ uniqid, onClick, children }: { uniqid: string; onClick: () => void; children: ReactNode }) => {
    const theme = useTheme();
    const styles = useAppSelector((state) => Widget.selectors.selectWidgetWrapperStyle(state, uniqid), shallowEqual);

    const initialValues = useMemo(() => {
        return {
            color: styles && styles['color'] ? String(styles['color']) : theme.color.black,
            backgroundColor:
                styles && styles['background-color'] ? String(styles['background-color']) : theme.color.white,
            borderRadius: styles && styles['border-radius'] ? `${styles['border-radius']}px` : '0px',
            borderColor: styles['border-color'] ? String(styles['border-color']) : theme.color.black,
            borderWidth: styles['border-width'] ? `${styles['border-width']}px` : '0px',
            borderStyle: styles['border-style'] ? String(styles['border-style']) : 'none',
        };
    }, [styles, theme]);

    return (
        <UIWrapper
            onClick={onClick}
            style={{
                color: initialValues.color,
                borderColor: initialValues.borderColor,
                borderStyle: initialValues.borderStyle,
                borderRadius: initialValues.borderRadius,
                borderWidth: initialValues.borderWidth,
                backgroundColor: initialValues.backgroundColor,
                overflow: Number(initialValues.borderRadius) > 0 ? 'hidden' : 'initial',
            }}>
            {children}
        </UIWrapper>
    );
};

export const WidgetStyleWrapper = WidgetStyle;
